import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-multi-lang";
import { agentInviteStart } from "../../store/slices/AgentSlice";
import { ButtonLoader } from "../Helper/Loader";

const AgentInviteModal = ({ show, onHide, agent }) => {
  const dispatch = useDispatch();
  const t = useTranslation("agent_invite");
  const agentInvite = useSelector((state) => state.agent.agentInvite);

  if (!agent) return null;

  const isInviting =
    agentInvite.buttonDisable &&
    agentInvite?.data?.merchant_agent_id === agent?.id;

  const handleSend = () => {
    dispatch(agentInviteStart({ merchant_agent_id: agent.id }));
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t("title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-1">{t("description")}</p>
        <div className="fw-semibold">{agent?.name || agent?.email}</div>
        <div className="text-muted small">{agent?.email}</div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide}>
          {t("cancel")}
        </Button>
        <Button
          className="snapgopay-payment-btn"
          onClick={handleSend}
          disabled={agentInvite.buttonDisable}
        >
          {isInviting ? <ButtonLoader /> : t("send")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AgentInviteModal;
